"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var material_1 = require("@mui/material");
var Box_1 = __importDefault(require("@mui/material/Box"));
exports.default = (0, material_1.styled)(Box_1.default)(function (_a) {
    var theme = _a.theme, maxWidth = _a.maxWidth;
    return ({
        display: 'flex',
        flexDirection: 'column',
        margin: theme.spacing(1, 'auto', 2, 'auto'),
        padding: theme.spacing(0, 6, 0, 6),
        height: '100%',
        width: '100%',
        maxWidth: maxWidth !== null && maxWidth !== void 0 ? maxWidth : 1000,
    });
});
